import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dialog-wrapper',
  templateUrl: './dialog-wrapper.component.html',
  styleUrls: ['./dialog-wrapper.component.scss']
})
export class DialogWrapperComponent {
  /** Permet de savoir si on ferme le dialog (pour jouer l'anim) */
  @Input() isClosing = false;

  /** Événement quand l'anim est terminée */
  @Output() animationEnd = new EventEmitter<void>();

  onAnimationEnd() {
    this.animationEnd.emit();
  }
}
